export enum MaterialAlertIconClass {
    danger = 'icon-error-severe',
    info = 'icon-info',
    success = 'icon-tick-circle',
    warning = 'icon-Warning-important',
}
